import { defineMessages, useIntl } from 'react-intl';
import { QRCodeSVG } from 'qrcode.react';
import { FormattedMessage } from 'react-intl';
import { type MfaSetupPageProps } from './MfaTypes';
import { MfaSubheading, QrCodeContainer } from './Mfa.styled';
import { MfaLayout } from './MfaLayout';
import { MfaCodeForm } from './MfaCodeForm';

const messages = defineMessages({
  subheading: {
    id: 'mfaSetupSubHeading',
    defaultMessage: 'Set up authenticator app'
  },
  headline: {
    id: 'mfaSetupHeadline',
    defaultMessage: 'Download an authenticator app on your phone or tablet.'
  },
  codeLabel: {
    id: 'mfaSetupCodeLabel',
    defaultMessage: 'Verification code'
  },
  codePlaceholder: {
    id: 'mfaSetupCodePlaceholder',
    defaultMessage: 'Enter your code...'
  },
  verifyButton: {
    id: 'mfaSetupVerifyButton',
    defaultMessage: 'Submit'
  },
  qrCodeAlt: {
    id: 'mfaSetupQrCodeAlt',
    defaultMessage: 'Scan QR code to set up your authenticator app'
  }
});

export const MfaSetupPage = ({ communityName, hasLogo, logoUrl, provisioningUri, error }: MfaSetupPageProps) => {
  const intl = useIntl();

  return (
    <MfaLayout
      communityName={communityName}
      hasLogo={hasLogo}
      logoUrl={logoUrl}
      headline={messages.headline}
      error={error}
      headerExtra={
        <MfaSubheading>
          <FormattedMessage {...messages.subheading} />
        </MfaSubheading>
      }
    >
      <QrCodeContainer role="img" aria-label={intl.formatMessage(messages.qrCodeAlt)}>
        <QRCodeSVG value={provisioningUri} size={200} level="M" aria-hidden="true" />
      </QrCodeContainer>

      <MfaCodeForm
        codeLabel={intl.formatMessage(messages.codeLabel)}
        codePlaceholder={intl.formatMessage(messages.codePlaceholder)}
        buttonLabel={messages.verifyButton}
      />
    </MfaLayout>
  );
};
